;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Share = Model.Share.extend({
		game_type: 'JMC Footy Tipping',
		defaults: {
			templates: {
				share: {
					title:   _.template('<%= game_type %>'),
					message: _.template('I have just registered for <%= game_type %>! ' +
					'Sign up and join in here'),
					img:     'share.jpg'
				},
				invite: {
					title:   _.template('<%= game_type %>'),
					message: _.template('<%= team %> is entered in <%= league %> comp on <%= game_type %>! ' +
					'Looking forward to season 2021. Sign up and join here'),
					img:     'share.jpg'
				}
			}
		},

		share(data) {

			let template = this.get('templates').share;

			data.game_type = this.game_type;
			data.type_share = 'team';

			if (data.type == 'facebook') {
				this._show().facebook(template, data);
			}
			else if (data.type == 'twitter') {
				this._show().twitter(template, data);
			}

			return this;
		},

		invite: function(data) {
			let template = this.get('templates').invite;

			data.game_type = this.game_type;
			data.type_share = 'league';

			if (data.type == 'facebook') {
				this._show().facebook(template, data);
			}
			else if (data.type == 'twitter') {
				this._show().twitter(template, data);
			}

			return this;
		},

		_show() {

			return {

				facebook(template, data) {
					let
						json = {
							user_id: (data.user_id) ? data.user_id : '',
							league_id: (data.league_id) ? data.league_id : '',
							round: data.round ? data.round : '',
							time_cache: moment().unix()
						};
					APP.FGPFacebook.share(`${CONFIG.FRONT_PROTOCOL + CONFIG.FB_SHARE_URL + data.type_share}/${btoa(encodeURIComponent(JSON.stringify(json)))}`)

					return this;
				},
				twitter: function(template, data) {
					var message = template.message(data) || '',
						link    = template.link ? CONFIG.ABSPATH + template.link : CONFIG.ABSPATH;

					if( data.type_share == "league" ) {
						link = CONFIG.ABSPATH + '#tipping/leagues/'+data.league_id+'/join/'+ data.code;
					}

					window.open(
						'https://twitter.com/intent/tweet?url=' + encodeURIComponent(link) +
						'&text=' + encodeURIComponent(message),
						'twitter-share-dialog',
						'width=626,height=436'
					);

					return this;
				}
			};

		}
	});

}(window, APP, Backbone, Marionette, $, _));